import React from 'react';

import Input from '../Input';

function BooleanInput({id, label, question, values, onChange, invalid}) {
  const value = values.length > 0 ? values[0].toString().toLowerCase() : null;

  return (
    <Input
      id={id ? id : `answer-${question.id}`}
      label={label} 
      type="select" 
      value={value || ''} 
      onChange={e => onChange([e.target.value], e.target.value !== '')} 
      invalid={invalid}>
      {value === null && <option value="">Choose an answer...</option>}
      <option value="true">Yes (True)</option>
      <option value="false">No (False)</option>
    </Input>
  );
}

export default BooleanInput;
